import { render, staticRenderFns } from "./personal-base.vue?vue&type=template&id=65e1b3a6&scoped=true&"
import script from "./personal-base.vue?vue&type=script&lang=js&"
export * from "./personal-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1b3a6",
  null
  
)

export default component.exports